export const cardisTheme = {
  colors: {
    primary: '#003057', // Cardis blue (official brand color)
    secondary: '#0667A0', // Cardis second blue
    gold: '#c9a961', // Cardis gold (alias for secondary)
    white: '#ffffff',
    text: '#000000', // Black for body text
    textDark: '#1a1a1a', // Dark text for headings
    textLight: '#666666',
    textGray: '#666666', // Alias for textLight
    textMuted: '#999999',
    border: '#e0e0e0',
    borderLight: '#f0f0f0',
    background: '#ffffff',
    backgroundLight: '#f8f8f8', // Light background for cards
    backgroundGray: '#f5f5f5', // Light gray for boxes
    danger: '#dc3545',
    warningLight: '#fff3cd',
    successLight: '#d4edda',
  },
  fonts: {
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
    mono: "'Courier New', monospace",
  },
  fontSizes: {
    micro: '10px',
    small: '12px',
    body: '14px',
    medium: '16px',
    large: '18px',
    xlarge: '24px',
    huge: '32px',
    title: '48px',
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    pageMargin: '20mm',
    sectionGap: '24px',
    contentGap: '16px',
    smallGap: '8px',
    tinyGap: '4px',
  },
  print: {
    pageSize: 'A4',
    pageWidth: '210mm',
    pageHeight: '297mm',
    hideEditable: true,
  },
}

export type CardisTheme = typeof cardisTheme
